"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function ActiveCallsIcon() {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "34", height: "34", viewBox: "0 0 34 34", id: "active-calls-icon" },
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("path", { fill: "#8F96A0", d: "M4 10.453v9.183L14.365 30h9.198L27 26.575l-4.573-4.596-4.618 4.622L7.391 16.208l4.624-4.66L7.415 7z" }),
            React.createElement("path", { fill: "#B2B9C2", d: "M7.438 16L4 19.48 14.508 30 18 26.55z" }),
            React.createElement("path", { fill: "#8BB832", d: "M30 5.11L16.113 5l-.09 10.999L16 19l3.083-2.975 10.833.089z" }),
            React.createElement("path", { fill: "#FFF", d: "M22.908 10.999l.233.002c1.485.01 2.7 1.321 2.859 2.999l-6-.049c.186-1.675 1.422-2.965 2.908-2.952zM23.056 7a1.51 1.51 0 0 1 1.505 1.516 1.51 1.51 0 0 1-1.529 1.491 1.509 1.509 0 0 1-1.503-1.516c.008-.83.69-1.498 1.527-1.49z" }))));
}
exports.ActiveCallsIcon = ActiveCallsIcon;
